import React, { useContext, useEffect, useState } from 'react';
import { FormControl, Select, MenuItem, Typography } from '@mui/material';
import { Language } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';
import { useLocale } from '../../lib/contexts/LocaleContext';
import { postCurrentLocale } from '../../lib/api/postCurrentLocale';
import { getLocales } from '../../lib/i18n';
import ListItemText from '@mui/material/ListItemText';
import { ThemeContext } from '../../lib/contexts/ThemeContext';
import { LocaleContext } from '../../lib/contexts/LocaleContext';

const LanguagePicker = () => {
  const { lang, locale, changeLocale } = useContext(LocaleContext);
  const locales = getLocales();
  const {
    state: { darkMode },
  } = useContext(ThemeContext);
  const [language, setLanguage] = useState('');

  useEffect(() => {
    setLanguage(lang || '');
  }, [lang]);

  // console.log('lang: ', lang, ' and here is locale: ', locale);
  const handleLanguageChange = async (event) => {
    const newLanguage = event.target.value;
    changeLocale(newLanguage);
    try {
      const response = await postCurrentLocale(newLanguage);
      // console.log('Locale updated:', response);
    } catch (error) {
      console.error('Error updating locale:', error);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div style={{ paddingRight: '15%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '8px' }}>
          <Language
            sx={{ mr: 1 }}
            style={{ transform: 'scale(0.9)', color: 'grey' }}
          />
          <ListItemText
            primary={'Select Language'}
            sx={{ color: darkMode ? '#ffffff' : '#000000' }}
          />
        </div>
      </div>
      <Tooltip
        placement="bottom"
        title="Select Language"
        aria-label="Select Language"
        PopperProps={{
          sx: {
            pointerEvents: 'none',
          },
        }}
      >
        <Typography
          component="div"
          color="textSecondary"
          gutterBottom
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', mr: 4, mt: 1 }}
        >
          <FormControl
            variant="outlined"
            sx={{ minWidth: 100, height: 30 }}
          >
            <Select
              value={language}
              onChange={handleLanguageChange}
              displayEmpty
              inputProps={{ 'aria-label': 'Select Language' }}
              sx={{
                height: 30,
                fontSize: '0.875rem',
                color: darkMode ? '#ffffff' : '#000000',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: darkMode ? '#ffffff' : '#000000',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: darkMode ? '#ffffff' : '#000000',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: darkMode ? '#ffffff' : '#000000',
                },
              }}
            >
              {locales.map((loc) => (
                <MenuItem
                  key={loc.code}
                  value={loc.code}
                >
                  {loc.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Typography>
      </Tooltip>
    </div>
  );
};

export default LanguagePicker;

/*
                <div style={{paddingRight: '15%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                  <div style={{display: 'flex', flexDirection: 'row'}}>
                    <ListItemText primary={'Select Language'} />
                  </div>
                </div>

*/
